import axios from 'axios';
import { TAXES_ENDPOINT } from '@/constants/endpoints'; // I need to define TAXES_ENDPOINT
import authHeader from "@/services/auth-header";
import QueryUtils from "@/utils/QueryUtils";
import Page from "@/dto/taxation/Page";
import TaxObligationDTO from "@/dto/tax/TaxObligationDTO";
import TaxObligationFilter from "@/dto/tax/TaxObligationFilter";
import TaxObligationPayload, { TaxObligationDocumentPayload } from "@/dto/tax/TaxObligationPayload";
import TaxObligationCommentPayload from "@/dto/tax/TaxObligationCommentPayload";
import TaxObligationLedgerPayload from "@/dto/tax/TaxObligationLedgerPayload";
import TaxObligationReconciliationPayload from "@/dto/tax/TaxObligationReconciliationPayload";
import { TaxObligationPaymentPayload } from "@/dto/tax/TaxObligationPaymentPayload";
import { UpdateTaxPaymentPayload } from "@/dto/tax/UpdateTaxPaymentPayload";
import { UpdateTaxAssessmentPayload } from "@/dto/tax/UpdateTaxAssessmentPayload";

class TaxObligationService {
    getTaxObligations(filter: TaxObligationFilter) {
        // Backend takes 0-indexed page number if it maps to Spring Data Pageable
        // Assuming we need to adjust standard pageNumber from 1-indexed to 0-indexed
        const filterCopy = { ...filter, pageNumber: filter.pageNumber > 0 ? filter.pageNumber - 1 : 0 };
        const queryString = QueryUtils.objectToQueryString(filterCopy);
        return axios.get<Page<TaxObligationDTO>>(`${TAXES_ENDPOINT}${queryString}`, { headers: authHeader() });
    }

    createTaxObligation(payload: TaxObligationPayload) {
        return axios.post<TaxObligationDTO>(`${TAXES_ENDPOINT}`, payload, { headers: authHeader() });
    }

    getTaxObligation(id: number) {
        return axios.get<TaxObligationDTO>(`${TAXES_ENDPOINT}/${id}`, { headers: authHeader() });
    }

    updateTaxObligation(id: number, payload: TaxObligationPayload) {
        return axios.put<TaxObligationDTO>(`${TAXES_ENDPOINT}/${id}`, payload, { headers: authHeader() });
    }

    addComment(id: number, payload: TaxObligationCommentPayload) {
        return axios.post<TaxObligationDTO>(`${TAXES_ENDPOINT}/${id}/comments`, payload, { headers: authHeader() });
    }

    addLedgerRecord(id: number, payload: TaxObligationLedgerPayload) {
        return axios.post<TaxObligationDTO>(`${TAXES_ENDPOINT}/${id}/ledger`, payload, { headers: authHeader() });
    }

    updateLedgerRecordAmount(id: number, recordId: number, payload: UpdateTaxAssessmentPayload) {
        return axios.patch<void>(`${TAXES_ENDPOINT}/${id}/ledger/${recordId}`, payload, { headers: authHeader() });
    }

    addReconciliationRecord(id: number, payload: TaxObligationReconciliationPayload) {
        return axios.post<TaxObligationDTO>(`${TAXES_ENDPOINT}/${id}/reconciliation`, payload, { headers: authHeader() });
    }

    addPayment(id: number, payload: TaxObligationPaymentPayload) {
        return axios.post<TaxObligationDTO>(`${TAXES_ENDPOINT}/${id}/payments`, payload, { headers: authHeader() });
    }

    updatePayment(id: number, paymentId: number, payload: UpdateTaxPaymentPayload) {
        return axios.put<TaxObligationDTO>(`${TAXES_ENDPOINT}/${id}/payments/${paymentId}`, payload, { headers: authHeader() });
    }

    addDocument(id: number, payload: TaxObligationDocumentPayload) {
        return axios.post<TaxObligationDTO>(`${TAXES_ENDPOINT}/${id}/documents`, payload, { headers: authHeader() });
    }

    deleteDocument(id: number, documentId: number) {
        return axios.delete<TaxObligationDTO>(`${TAXES_ENDPOINT}/${id}/documents/${documentId}`, { headers: authHeader() });
    }
}

export default new TaxObligationService();
